import { defineComponent as _defineComponent } from 'vue'
import CcModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcModal.ts.vue';
import { ImageCreative } from '@/views/Automation/CampaignCreatorV2/helpers/facebook/AdCreative';
import ImageEditor from '@sh/components/Utils/ImageEditor/ImageEditor.vue';
import ImageHelper from '@sh/components/Utils/ImageEditor/ImageHelper';
import { ImageEditorType } from '@sh/types/ImageTypes';

interface Props {
  image: NullableType<ImageCreative>;
}

interface Emits {
  (event: 'onCancel'): void;
  (event: 'onSave', value: ImageCreative): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcEditImageModal.ts',
  props: {
    image: null
  },
  emits: ["onCancel", "onSave"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'onCancel'): void;
  (event: 'onSave', value: ImageCreative): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  image: NullableType<ImageCreative>;
};





function onSaveClick() {
  const saveButton = document.getElementsByClassName('FIE_topbar-save-button')[0];
  (saveButton as HTMLButtonElement)?.click();
}

function onImageEdit(image: ImageEditorType) {
  if (!props.image) {
    return;
  }

  const editedImage: ImageCreative = {
    ...props.image,
    image_url: image.imageBase64,
    width: image.width,
    height: image.height,
    // image_crops: {},
    cropVariations: {},
    name: image.name,
    size: ImageHelper.getBase64ImageSize(image.imageBase64) * 1000,
  };
  emits('onSave', editedImage);
}

return { __sfc: true,props, emits, onSaveClick, onImageEdit, CcModal, ImageEditor }
}

})